import { Component } from '@angular/core';

@Component({
  template: '<h2>preview mode goes here</h2>'
})
export class PageNotFoundComponent {}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/dashboard/not-found.component.ts